import { RFIconProps } from "../types";

export default function NightIcon(props: RFIconProps) {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M10.2446 8.88967C9.28894 8.89118 8.35009 8.63158 7.52457 8.13753C6.69905 7.64348 6.01664 6.93281 5.54746 6.07855C5.07828 5.2243 4.83927 4.25726 4.85498 3.27684C4.87068 2.29642 5.14055 1.33797 5.63684 0.5C4.73631 0.629895 3.88249 0.991587 3.15496 1.55137C2.42742 2.11115 1.84985 2.8508 1.47607 3.70138C1.10229 4.55196 0.944466 5.48579 1.01731 6.41583C1.09016 7.34587 1.3913 8.24185 1.89268 9.02027C2.39405 9.79869 3.07934 10.4342 3.88466 10.8676C4.68999 11.301 5.58915 11.5181 6.49834 11.4988C7.40752 11.4795 8.29714 11.2243 9.08429 10.7571C9.87143 10.2898 10.5305 9.62575 11 8.8267C10.7501 8.8673 10.4976 8.88835 10.2446 8.88967Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
